export const formatNumber = (numberString: string | undefined): string  => {
    if (numberString === undefined) {
        return "Undefined number";
    }
    const number = parseFloat(numberString);
    if (isNaN(number)) {
        return "0";
    }
    return number.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}